import * as React from "react";
import PedidoSelectForm from "../components/PedidoSelectForm.js";

function PedidoSelect() {
  return <PedidoSelectForm />;
}

export default PedidoSelect;
